<template>
<f7-app :params="f7params" >

	<!-- Left panel with cover effect when hidden -->
	<f7-panel left cover theme-dark :visible-breakpoint="960">
		<f7-view>
			<f7-page>
				<template v-for="(tMenu, i) in leftMenu">
					<f7-navbar v-if="tMenu.menuType != 'INVISIBLE_MENU'" :key="'t' + i">
						<div class="title">
							<img src="static/logo/logo.png" style="vertical-align:middle;"> 
							<!--{{tMenu.menuTitle}}-->
						</div>
					</f7-navbar>
					<template v-for="(gMenu, j) in tMenu.childList">
						<template v-if="gMenu.menuType != 'INVISIBLE_MENU'">
							<f7-block-title :key="'ga' + i+j">{{gMenu.menuTitle}}</f7-block-title>
							<div class="list" :key="'gb' + i+j">
								<ul>
									<template v-for="(sMenu, k) in gMenu.childList">
										<template v-if="sMenu.menuType != 'INVISIBLE_MENU'">
											<li :key="'s' + i+j+k" class="menu-panel-item" :class="sMenu.selected ? 'selected':''">
												<a :href="sMenu.url" data-view=".view-main" data-clear-previous-history="true" class="item-link panel-close">
													<div class="item-content">
														<div class="item-inner">
															<div class="item-title">{{sMenu.menuTitle}}</div>
														</div>
													</div>
												</a>
											</li>
										</template>
									</template>
								</ul>
							</div>
						</template>
					</template>
				</template>			
			</f7-page>
		</f7-view>
	</f7-panel>


	<!-- Right panel with reveal effect-->
	<f7-panel right reveal theme-dark>
		<f7-view>
			<f7-page>
				<f7-list>
					<li class="menu-panel-item">
						<div class="title">
							<a class="item-link panel-close" style="background-color:#4d5163" v-if="isUser()" href="/user-info" data-view=".view-main" data-clear-previous-history="true">
								<i class="f7-icons" style="vertical-align: text-bottom;">person_crop_square</i>
								<span>{{userName}}</span>
								<span v-if="isStudent()">(사용자 코드 : <font style="color:#00aaff">{{userCode}}</font>)</span>
							</a>
							<template v-else>
								<i class="f7-icons" style="vertical-align: text-bottom;">person_crop_square</i>
								<span>{{userName}}</span>
							</template>
						</div>
					</li>
					<li v-if="isStudent()">
						<div class="item-content">
							<div class="item-inner">
								<div class="item-title">
									이번달 : {{monthPoint}}점
								</div>
								<div class="item-title">
									누  적 : {{accPoint}}점
								</div>
							</div>							
						</div>									
					</li>
					<li v-if="isUser()">
						<a class="item-link panel-close" v-on:click="logout">
							<div class="item-content">
								<div class="item-inner">
									<div class="item-title">로그아웃</div>
								</div>
							</div>
						</a>
					</li>
					<li v-else class="menu-panel-item">
						<a class="item-link panel-close" href="/login" data-view=".view-main" data-clear-previous-history="true">
							<div class="item-content">
								<div class="item-inner">
									<div class="item-title">로그인</div>
								</div>
							</div>
						</a>
					</li>					
				</f7-list>

				<f7-block-title>이용안내</f7-block-title>
				<f7-list>
					<li class="menu-panel-item">
						<a class="item-link panel-close" data-view=".view-main" data-clear-previous-history="true" v-on:click="openInfo('use');">
							<div class="item-content">
								<div class="item-inner">
									<div class="item-title">이용약관</div>
								</div>
							</div>
						</a>
					</li>
					<li class="menu-panel-item">
						<a class="item-link panel-close" data-view=".view-main" data-clear-previous-history="true" v-on:click="openInfo('indi');">
							<div class="item-content">
								<div class="item-inner">
									<div class="item-title">개인정보취급방침</div>
								</div>
							</div>
						</a>
					</li>
				</f7-list>

				<f7-block-title>프로그램 환경</f7-block-title>
				<f7-list>
					<li class="menu-panel-item">
						<a class="item-link panel-close" href="/config" data-view=".view-main" data-clear-previous-history="true">
							<div class="item-content">
								<div class="item-inner">
									<div class="item-title">환경설정</div>
								</div>
							</div>
						</a>
					</li>
					<li class="menu-panel-item">
						<a class="item-link panel-close" href="/program-info" data-view=".view-main" data-clear-previous-history="true">
							<div class="item-content">
								<div class="item-inner">
									<div class="item-title">프로그램 정보</div>
								</div>
							</div>
						</a>
					</li>
				</f7-list>		

				<!-- test layout-->
				<f7-block-title>레이아웃 리스트(나중에 삭제)</f7-block-title>
				<f7-list>
					<li class="menu-panel-item">
						<a class="item-link panel-close" href="/test-layout1" data-view=".view-main" data-clear-previous-history="true">
							<div class="item-content">
								<div class="item-inner">
									<div class="item-title">레이아웃1</div>
								</div>
							</div>
						</a>
					</li>			
						<li class="menu-panel-item">
						<a class="item-link panel-close" href="/pwa/campgnrl_member/main/dashboard" data-view=".view-main" data-clear-previous-history="true">
							<div class="item-content">
								<div class="item-inner">
									<div class="item-title">레이아웃1</div>
								</div>
							</div>
						</a>
					</li>				
				</f7-list>			
		
			</f7-page>
		</f7-view>
	</f7-panel>


	<!-- Your main view, should have "view-main" class -->
	<f7-view main class="safe-areas"></f7-view>

	<equation-dialog id="equation-popup"></equation-dialog>
	
</f7-app>
</template>

<style src="mathlive/dist/mathlive.core.css"></style>
<style src="mathlive/dist/mathlive.css"></style>
<style src="video.js/dist/video-js.min.css"></style>

<script>
	import routes from '../js/routes.js';

	import MODULE from '../js/common/module.js';
	import API from '../js/common/api';
	import AUTH from '../js/common/auth';
	import PAGES from '../js/pages';
	import CONST from '../js/common/constant';

	import EquationDialog from './answer/equation-dialog';

	export default {
		components: {
			EquationDialog,
		},
		popup: {
			backdrop: true,
			closeByBackdropClick: false,
		},
		data() {
			return {
				// Framework7 Parameters
				f7params: {
					name: '벤자민의숲', // App name
					version: 'v10.0.0',
					theme: 'auto', // Automatic theme detection
					/* 메뉴쪽에 비정상 동작하여 주석처리...
					view: {
						pushState: true,
					},
					//*/
					// App root data
					data: function () {
						return {
							user: {
								firstName: 'John',
								lastName: 'Doe',
							},

						};
					},

					// App routes
					routes: routes,
					// Register service worker
					serviceWorker: {
						path: 'service-worker.js',
					},
				},
			}
		},
		computed: {
			leftMenu() {
				if (AUTH.isGuest()) {
					var allowMenuList = [
						{
							menuTitle: "벤자민의숲",
							menuType: "MENU_GROUP",
							url: "",
							childList: [
								{
									menuTitle: "사용자 계정",
									menuType: "MENU_GROUP",
									url: "",
									childList: [
										{
											menuTitle: "로그인",
											menuType: "GO_UR",
											url: PAGES.LOGIN_PAGE,
											childList: []
										},
										{
											menuTitle: "ID/PW 찾기",
											menuType: "GO_UR",
											url: PAGES.IDPW_PAGE,
											childList: []
										},
										{
											menuTitle: "회원가입",
											menuType: "GO_UR",
											url: PAGES.SELECT_REGIST_PAGE,
											childList: []
										}
									]
								},
								{
									menuTitle: "진단 및 검사",
									menuType: "MENU_GROUP",
									url: "",
									childList: [
										{
											menuTitle: "진단평가",
											menuType: "GO_UR",
											url: PAGES.MENU_GUEST_DIAG_MAIN_PAGE,
											childList: []
										},
										{
											menuTitle: "인적성평가",
											menuType: "GO_UR",
											url: PAGES.MENU_GUEST_PQAT_MAIN_PAGE,
											childList: []
										}
									]
								}
							]
						}
					];
					return allowMenuList;
				} else {
					const userInfo = AUTH.getUserInfo();
					return userInfo.allowMenuList;
					/*
					return userInfo.allowMenuList.filter( item => {
						return (item.menuType != "INVISIBLE_MENU");
					});
					*/
				}
			},
			userName() {
				if (AUTH.isGuest()) {
					return "GUEST";
				} else {
					let userInfo = AUTH.getUserInfo();
					return userInfo.USER_NAME;
				}
			},
			monthPoint() {
				let userInfo = AUTH.getUserInfo();
				return userInfo.MONTH_POINT;
			},
			accPoint() {
				let userInfo = AUTH.getUserInfo();
				return userInfo.ACC_POINT;
			},
			userCode(){
				let userInfo = AUTH.getUserInfo();
				return CONST.userCodePrefix+userInfo.USER_CODE;
			},		
		},
		methods: {
			isUser() {
				return !AUTH.isGuest();
			},
			isStudent() {

				if(!AUTH.isGuest()) {
					let userInfo = AUTH.getUserInfo();

					if(userInfo.USER_TYPE == "student") {
						return true;
					}else {
						return false;
					}
				}else {
					return false;
				}
			},
			logout() {
				var _this = this;

				var panel = this.$f7.panel.get('.panel-right');
				panel.close();

				AUTH.removeUserInfo();
				AUTH.removeAccessToken();

				_this.$utils.nextTick(function() {
					PAGES.login();
				});
			},
			alertLoginData() {
				this.$f7.dialog.alert('Username: ' + this.username + '<br>Password: ' + this.password);
			},
			initUserInfo() {
				let userInfo = AUTH.getUserInfo();
				if (userInfo == null || userInfo == undefined) {

					const accessToken = AUTH.getAccessToken();
					if (MODULE.Util.isEmpty(accessToken)) {
						PAGES.login();
						return;
					}

					API.tokenLogin()
						.then(function(data) {																
							const userMainPage = AUTH.getUserMainPage();		
							var param = {
								firstLogin : true
							}
							PAGES.goPage(userMainPage,param);										
						})
						.catch(function(code) {
							MODULE.UITool.catchBlock(code, PAGES, AUTH);
						});
				}
			},
			onBackKeyDown: function() {

				MODULE.DialogBox.message("back !!!!");

				var leftPanel = this.$f7.panel.get('.panel-left');
				var rightPanel = this.$f7.panel.get('.panel-right');

				if (leftPanel.opened) {
					leftPanel.close();
					return false;
				} else if (rightPanel.opened) {
					rightPanel.close();
					return false;
				} else if ($$('.modal-in').length > 0) {					
					this.$f7.dialog.close();
					this.$f7.popup.close();
					return false;
				} else if (this.$f7.views.main.router.url == '/home/') {
					navigator.app.exitApp();
				} else {
					this.$f7.views.main.router.back();
				}
			},
			openInfo(type) {       
        let url = "";
        let param = {};
        if(type == "use") {
          url = PAGES.USE_INFO_PAGE;          
        } else {
          url = PAGES.INDI_INFO_PAGE;        
        }
        
        PAGES.popPage(url,param); 
      }
		},
		mounted() {
			this.$f7ready((f7) => {
				
				// android에서 back버튼 이벤트 못받는듯... 추후 점검.
				document.addEventListener('backbutton', this.onBackKeyDown, false);

				window.deferredPrompt = undefined;

				window.addEventListener("beforeinstallprompt", event => {
					window.deferredPrompt = event;

					event.preventDefault();
				});


				this.initUserInfo();

			});
		}
	}
</script>